import createFilter from 'redux-persist-transform-filter';

const sessionPersistFilter = createFilter('session', [
  'user',
  'profile',
  'profiles',
  'type'
]);

export { sessionPersistFilter };
